import { render, staticRenderFns } from "./ColorHelper.vue?vue&type=template&id=0149d3bf"
import script from "./ColorHelper.vue?vue&type=script&lang=js"
export * from "./ColorHelper.vue?vue&type=script&lang=js"
import style0 from "./ColorHelper.vue?vue&type=style&index=0&id=0149d3bf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports